// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1De4p","clinicsSelect":"TableHeading_clinicsSelect__1DmoF"};